import { Campaign } from '~/services/AccommodationService';

export const ALL_CAMPAIGN_STATUSES: Array<Campaign['status']> = ['draft', 'active'];

export const campaignStatusPillProps = (
  status: Campaign['status'],
): { label: string; color: 'success' | 'default' } => ({
  label: status,
  color: status === 'active' ? 'success' : 'default',
});
